export { default as PopUpCreateTerritory} from './popUpCreateTerritory';